import { FC, memo, useRef, useState, type ReactNode } from 'react';
import { v4 as uuidv4 } from 'uuid';
import classNames from 'classnames';
// Import Components
import { Button } from '@geneui/components';
// Import Styles
import styles from './expandableKeyValue.module.scss';

interface Props {
    label: string;
    value: string | number;
    children: ReactNode;
    isExpandable?: boolean;
}

const ExpandableKeyValue: FC<Props> = ({ label, value, children, isExpandable = true }) => {
    const [isDroppableAreaVisible, setIsDroppableAreaVisible] = useState(false);
    const droppableAreaContentId = useRef(uuidv4()).current;

    const buttonIcon = isDroppableAreaVisible ? 'bc-icon-arrow-up' : 'bc-icon-arrow-down';

    return (
        <div className={styles.container}>
            <div className={styles.labelValue}>
                <div className={styles.label}>{label}</div>
                <Button
                    appearance="minimal"
                    aria-expanded={isDroppableAreaVisible}
                    aria-controls={droppableAreaContentId}
                    cornerRadius="smooth"
                    icon={isExpandable ? buttonIcon : undefined}
                    className={classNames(styles.button, { [styles.readOnly]: !isExpandable })}
                    onClick={() => isExpandable && setIsDroppableAreaVisible((prev) => !prev)}
                >
                    <span>{value}</span>
                </Button>
            </div>
            {isDroppableAreaVisible && (
                <div id={droppableAreaContentId} className={styles.droppableArea}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default memo(ExpandableKeyValue);
